import { differenceInDays, format } from "date-fns";
import { tr, enGB } from "date-fns/locale";
import { useTranslation } from "../../context/TranslationContext";
import Image from "next/image";
import React, { useContext } from "react";

const AvailableDates = ({
  availableDatesData,
  setAvailableDatesModal,
  error,
  setError,
  result,
  setResult,
  total,
  setTotal,
}) => {
  const localeData = process.env.NEXT_PUBLIC_LANGUAGE === "en" ? enGB : tr;
  const {
    availableDatesText,
    nightLabel,
    selectBtn,
    loadingDots,
    continueAnyway,
    availableDatesWarning,
  } = useTranslation();

  const selectAvailableDate = (e) => {
    setTotal([
      {
        startDate: new Date(e.Item1),
        endDate: new Date(e.Item2),
        key: "selection",
        isShow: 0,
      },
    ]);
  };

  const SendRequest = () => {
    setError(false);
    setAvailableDatesModal(false);

    //set success:200 on result
    setResult({
      ...result,
      success: 200,
      disableRetryCalc: true,
    });
  };
  return (
    <>
      {/* Kapatma Butonu */}
      <button
        onClick={() => setAvailableDatesModal(false)}
        className="absolute text-gray-500 top-4 right-4 hover:text-gray-800"
      >
        ✕
      </button>

      {/* Başlık */}
      <h2 className="max-w-xs mb-2 text-lg font-semibold text-center text-blue-900">
        {error}
      </h2>
      <p className="mb-8 text-sm text-center text-gray-600">
        {availableDatesText}
      </p>

      {/* Tarih Seçim Alanı */}
      <div
        className="grid gap-2 w-full justify-center pb-2 max-h-[400px] lg:max-h-[500px] overflow-y-auto"
        ref={parent}
      >
        {availableDatesData.length > 0 ? (
          availableDatesData?.map((item, key) => {
            return (
              <div
                key={key}
                className={`flex h-[58px] relative items-center justify-between px-2 gap-2 py-1 mb-4 border rounded-xl ${
                  item?.isMostSuitable ? "border-yellow-400" : ""
                }`}
              >
                {item?.isMostSuitable && (
                  <>
                    <Image
                      src={"/star.svg"}
                      width={16}
                      height={16}
                      className="absolute top-0 left-0 -mt-2 -ml-2"
                      alt=""
                    />
                  </>
                )}
                <div className="flex flex-col items-center content-center justify-center flex-1">
                  <div className="flex items-center justify-center gap-2 ">
                    <span className="text-sm font-bold text-orange-500">
                      {format(new Date(item.Item1), "d MMM ccc", {
                        locale: localeData,
                      })}
                    </span>
                    <span className="text-gray-500">→</span>
                    <span className="text-sm font-bold text-orange-500">
                      {format(new Date(item.Item2), "d MMM ccc", {
                        locale: localeData,
                      })}
                    </span>
                  </div>
                  <span className="text-sm text-gray-600">
                    {differenceInDays(
                      new Date(item.Item2),
                      new Date(item.Item1),
                    )}{" "}
                    {nightLabel}
                  </span>
                </div>

                <button
                  onClick={() => selectAvailableDate(item)}
                  className="px-3 py-1 font-semibold text-white transition-all rounded-full bg-black"
                >
                  {selectBtn}
                </button>
              </div>
            );
          })
        ) : (
          <div> {loadingDots}</div>
        )}
      </div>
      {result?.apiResponse?.Status == "AvailableHasWarningRule" && (
        <>
          {/* Talep Gönder Butonu */}
          <button
            onClick={SendRequest}
            className="w-full py-3 mb-4 font-semibold text-white rounded-lg bg-primary hover:bg-primary-dark"
          >
            {continueAnyway}
          </button>

          {/* Alt Açıklama */}
          <p className="text-xs text-center text-red-500">
            {availableDatesWarning}
          </p>
        </>
      )}
    </>
  );
};

export default AvailableDates;
